import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusDoneIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M16.3999 7.36001C16.0499 7.14001 15.5899 7.25001 15.3699 7.60001L10.9099 14.73L8.56994 12.01C8.29994 11.7 7.82994 11.66 7.50994 11.93C7.19994 12.2 7.15994 12.67 7.42994 12.99L10.4299 16.49C10.7399 16.87 11.3899 16.82 11.6399 16.4L16.6399 8.40001C16.8599 8.05001 16.7499 7.59001 16.3999 7.37001V7.36001Z"
        fill={color}
      />
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusDoneIcon.displayName = 'StatusDoneIcon';
